 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"OfferConfigurator~devicemanagement":"OfferConfigurator~devicemanagement","OfferConfigurator":"OfferConfigurator","fichaje":"fichaje","ManagementBase":"ManagementBase","devicemanagement":"devicemanagement","checkLowi":"checkLowi","dashBoard":"dashBoard","teletrabajo":"teletrabajo","retailX":"retailX","databaseManagement":"databaseManagement","rrhh~vacaciones":"rrhh~vacaciones","rrhh":"rrhh","storage":"storage","vacaciones":"vacaciones","detail":"detail","gerencia":"gerencia","tiendas":"tiendas"}[chunkId]||chunkId) + "." + {"chunk-1c085e0c":"6d453ba6","OfferConfigurator~devicemanagement":"eefd044d","chunk-1fb0f022":"eb62bf0a","OfferConfigurator":"3c87e30b","chunk-2428ad8d":"e80a4a8e","fichaje":"240d003f","chunk-2de108e8":"3905f093","chunk-45924956":"11629027","chunk-a2f5973a":"1f59651a","ManagementBase":"93e94da2","devicemanagement":"2aa3eaed","checkLowi":"79f10416","chunk-12a9aa60":"186c3e10","chunk-14edcb16":"4fe69209","chunk-59190a78":"4ed62788","chunk-62a5022e":"bd4360d1","dashBoard":"1bcd49ac","teletrabajo":"40b390cb","chunk-e8d3baf0":"30f8a906","chunk-2c122361":"b12799e8","chunk-243edee8":"50263a30","retailX":"15833762","chunk-a6aeb3a2":"3ab45bc3","chunk-1bce8ff4":"cea38dd8","chunk-8d2b3a32":"b4f707d6","chunk-4dc45006":"c216fa26","databaseManagement":"655129c7","rrhh~vacaciones":"82429bd1","rrhh":"bea71a88","storage":"be05c5c2","vacaciones":"4761faab","chunk-9f5f8c78":"c2f7d7e9","detail":"19417be2","gerencia":"33c7e2da","tiendas":"428bde2a","chunk-2d22497b":"a92eab96","chunk-1a7afec5":"4d3b2a54","chunk-2a83c94e":"a497d382","chunk-2d0a3499":"a5f41a4c","chunk-2d0a43fa":"9c486ee5","chunk-2d0aa212":"bf4cd504","chunk-2d0b728c":"eef394cc","chunk-2d0bda16":"c37979da","chunk-2d0bdf76":"11c9d816","chunk-2d0c4608":"7e962514","chunk-2d0c4674":"863a6cd4","chunk-2d0c498d":"e662da4f","chunk-2d0c73fe":"cbac1f31","chunk-2d0c8fa9":"f8835cc9","chunk-2d0cbe75":"f6abca3e","chunk-2d0d9fbd":"2a39ee63","chunk-2d0e19cf":"8c18480d","chunk-2d0e22c7":"f3f283a3","chunk-2d2132be":"76dbf973","chunk-2d213890":"9d5d2de1","chunk-2d215fe5":"3d45d0c8","chunk-2d21d701":"61dce7c5","chunk-2d2245b9":"1eba3bcf","chunk-2d22d5f9":"15e268d5","chunk-2d2302fe":"7099e46d","chunk-2d237208":"b86aa779","chunk-2d238a55":"6f87d6bb","chunk-36146695":"e724e697","chunk-51bd98c2":"1ec56fac","chunk-539efb4e":"1b3b2453","chunk-596255be":"4981b5d0","chunk-5ef3b00e":"0978ca77","chunk-7c3ef78f":"15422a34","chunk-beac4912":"dd2036fe"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1c085e0c":1,"OfferConfigurator~devicemanagement":1,"OfferConfigurator":1,"chunk-2428ad8d":1,"fichaje":1,"chunk-45924956":1,"chunk-a2f5973a":1,"ManagementBase":1,"devicemanagement":1,"checkLowi":1,"chunk-14edcb16":1,"chunk-59190a78":1,"chunk-62a5022e":1,"dashBoard":1,"teletrabajo":1,"chunk-e8d3baf0":1,"chunk-2c122361":1,"chunk-243edee8":1,"retailX":1,"chunk-a6aeb3a2":1,"chunk-1bce8ff4":1,"chunk-8d2b3a32":1,"chunk-4dc45006":1,"databaseManagement":1,"rrhh~vacaciones":1,"rrhh":1,"storage":1,"vacaciones":1,"chunk-9f5f8c78":1,"detail":1,"tiendas":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"OfferConfigurator~devicemanagement":"OfferConfigurator~devicemanagement","OfferConfigurator":"OfferConfigurator","fichaje":"fichaje","ManagementBase":"ManagementBase","devicemanagement":"devicemanagement","checkLowi":"checkLowi","dashBoard":"dashBoard","teletrabajo":"teletrabajo","retailX":"retailX","databaseManagement":"databaseManagement","rrhh~vacaciones":"rrhh~vacaciones","rrhh":"rrhh","storage":"storage","vacaciones":"vacaciones","detail":"detail","gerencia":"gerencia","tiendas":"tiendas"}[chunkId]||chunkId) + "." + {"chunk-1c085e0c":"e43be74d","OfferConfigurator~devicemanagement":"ea13750b","chunk-1fb0f022":"31d6cfe0","OfferConfigurator":"400740c3","chunk-2428ad8d":"7ffda656","fichaje":"26fae5fc","chunk-2de108e8":"31d6cfe0","chunk-45924956":"22d101cd","chunk-a2f5973a":"2930d3be","ManagementBase":"a3b738a3","devicemanagement":"deb6c472","checkLowi":"75b6ab1d","chunk-12a9aa60":"31d6cfe0","chunk-14edcb16":"8f446b35","chunk-59190a78":"1f3588b3","chunk-62a5022e":"dd9e6644","dashBoard":"b97573ea","teletrabajo":"50bdca3b","chunk-e8d3baf0":"c7d61dff","chunk-2c122361":"fb714f0d","chunk-243edee8":"a80c7ec3","retailX":"eb628b2f","chunk-a6aeb3a2":"e4960373","chunk-1bce8ff4":"b87e63b7","chunk-8d2b3a32":"4876211f","chunk-4dc45006":"45beabb3","databaseManagement":"357163ae","rrhh~vacaciones":"73f99dc4","rrhh":"a3c09960","storage":"19dbf128","vacaciones":"820ce244","chunk-9f5f8c78":"1b08253b","detail":"4002bf0e","gerencia":"31d6cfe0","tiendas":"8643465b","chunk-2d22497b":"31d6cfe0","chunk-1a7afec5":"31d6cfe0","chunk-2a83c94e":"31d6cfe0","chunk-2d0a3499":"31d6cfe0","chunk-2d0a43fa":"31d6cfe0","chunk-2d0aa212":"31d6cfe0","chunk-2d0b728c":"31d6cfe0","chunk-2d0bda16":"31d6cfe0","chunk-2d0bdf76":"31d6cfe0","chunk-2d0c4608":"31d6cfe0","chunk-2d0c4674":"31d6cfe0","chunk-2d0c498d":"31d6cfe0","chunk-2d0c73fe":"31d6cfe0","chunk-2d0c8fa9":"31d6cfe0","chunk-2d0cbe75":"31d6cfe0","chunk-2d0d9fbd":"31d6cfe0","chunk-2d0e19cf":"31d6cfe0","chunk-2d0e22c7":"31d6cfe0","chunk-2d2132be":"31d6cfe0","chunk-2d213890":"31d6cfe0","chunk-2d215fe5":"31d6cfe0","chunk-2d21d701":"31d6cfe0","chunk-2d2245b9":"31d6cfe0","chunk-2d22d5f9":"31d6cfe0","chunk-2d2302fe":"31d6cfe0","chunk-2d237208":"31d6cfe0","chunk-2d238a55":"31d6cfe0","chunk-36146695":"31d6cfe0","chunk-51bd98c2":"31d6cfe0","chunk-539efb4e":"31d6cfe0","chunk-596255be":"31d6cfe0","chunk-5ef3b00e":"31d6cfe0","chunk-7c3ef78f":"31d6cfe0","chunk-beac4912":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-9f5f8c78"]]);
 	return startupResult;
